import { commonStyles, buttonStyle } from "src/Library/CommonStyles";

export const INTTRABookingConfirmationModalStyles = (theme) => ({
  parentDiv: {
    padding: '24px',
    color: '#333333',
  },
  additionalDetailsTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333333',
    padding: '0 24px',
  },
  shipmentDetailsTitle: {
    fontSize: '16px',
    fontWeight: 600,
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
    paddingBottom: '12px',
    marginBottom: '24px',
    borderBottom: '1px solid #D9D9D9',
    color: '#333333',
  },
  editShipment: {
    color: '#1875F0',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  shipmentDetails: {
    paddingRight: '28px',
  },
  additionalDetails: {
    padding: '12px 0 24px 0',
    backgroundColor: '#FCFCFC',
  },
  shipmentLabel: {
    color: '#666666',
  },
  shipmentValue: {
    color: '#262626',
    fontWeight: 600,
    paddingLeft: '6px',
  },
  additonalDetailLabel: {
    color: '#262626',
    fontWeight: 600,
    fontSize: '12px',
  },
  additionalDetailsField: {
    ...commonStyles(theme).flexRow,
    padding: '0 24px 8px 24px',
  },
  additionalDetailsCargo: {
    fontWeight: 'bold',
    margin: '24px 0 14px 0',
    color: '#333333',
  },
  addMore: {
    cursor: 'pointer',
    color: '#1890FF',
  },
  paymentSelect: {
    width: '95%',
    '& .ant-select-selection__placeholder, .ant-select-search__field__placeholder': {
      fontSize: '12px'
    },
    '& .ant-select-selection-selected-value': {
      fontSize: '12px'
    },
  },
  paymentName: {
    width: '95%',
    fontSize: '12px !important',
  },
  paymentDetails: {
    marginBottom: '8px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid rgb(151,151,151, 0.2)',
    padding: '24px',
    marginTop: '12px',
  },
  shipmentModal: {
    minWidth: '1200px',
    color: '#262626',
    padding: '24px',
    '& .ant-modal-header': {
      margin: '0px 24px',
      padding: '16px 0',
    },
    '& .ant-modal-body': {
      padding: '18px 44px',
    },
  },
  shipmentModalLabel: {
    fontSize: '12px',
    fontWeight: 600,
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  shipmentForm: {
    marginBottom: 0,
  },
  haulage: {
    '& .ant-radio-wrapper': {
      fontSize: '12px !important',
    },
    '& .ant-radio-disabled + span': {
      color: '#262626',
    },
  },
  formTitles: {
    fontSize: '12px',
    color: '#262626',
    lineHeight: '25px',
    marginTop: '6px',
  },
  modalHeader: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
  },
  modalTitle: {
    fontWeight: 600,
    fontSize: '18px',
  },
  saveButton: {
    ...buttonStyle('#FFFFFF', '#1890FF', '1px solid #1890FF'),
    padding: '0 16px',
  },
  discard: {
    color: '#F5222D',
    cursor: 'pointer',
    marginRight: '16px',
    fontWeight: 600,
    fontSize: '14px',
  },
  etdTooltip: {
    '& .ant-tooltip-arrow': {
      left: 0,
    },
  },
  inttraError: {
    backgroundColor: 'rgba(245,34,45,0.08)',
    padding: '12px',
    fontWeight: 600,
    margin: '24px 24px 12px 24px',
    borderRadius: '2px',
    display: 'flex',
  },
  createAddressStyle: {
    color: '#1890FF',
    margin: '15px',
    cursor: 'pointer',
  },
  selectField: {
    width: '100%',
    '& .ant-select-selection__placeholder, .ant-select-search__field__placeholder': {
      fontSize: '12px'
    },
    '& .ant-select-selection-selected-value': {
      fontSize: '12px'
    },
  },
  suffixIcon: {
    '&:hover': {
      '& .ant-select-arrow': {
        right: '30px !important',
      }
    },
  },
});
